import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=1c4eb9e6&scoped=true&"
import script from "./Message.vue?vue&type=script&lang=js&"
export * from "./Message.vue?vue&type=script&lang=js&"
import style0 from "./Message.vue?vue&type=style&index=0&id=1c4eb9e6&prod&scoped=true&lang=css&"
import style1 from "./Message.vue?vue&type=style&index=1&id=1c4eb9e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4eb9e6",
  null
  
)

export default component.exports